export default __webpack_public_path__ + "static/media/project.e21c488d.webp";